import axios from 'axios';
import Alert from 'react-s-alert';
import {apiBaseUrl} from "../../../helpers/UrlHelper";
import {loginToken} from '../../../helpers/LocalStorageHelper'
import {isString} from '../../../helpers/DataHelper'
import {ConfigErrorAlert} from "../../../Config";
import {cancelLoginFormDispatch, loginFormServerValidationErrors} from "../../../pages/login/Login-Actions";
import store from '../../../Store'
import {scrollToError} from '../../../helpers/ScrollHelper'

const DEFAULT_LOGIN_ERROR_MESSAGE = `Login failed. Please check your credentials and try again.`;

function loginErrorMessage(data) {
    if (data && isString(data.message)) return data.message;
    if (data && data.payload && isString(data.payload.message)) return data.payload.message;
    return DEFAULT_LOGIN_ERROR_MESSAGE;
}

function notifyLoginError(data) {
    Alert.error(loginErrorMessage(data), ConfigErrorAlert);
}

function _success(success) {
    return {type: 'LOGIN_USER_SUCCESS', success};
}

function _error(error) {
    return {type: 'LOGIN_USER_ERROR', error};
}

function _processing(processing) {
    return {type: 'LOGIN_USER_PROCESSING', processing};
}

function loginUser() {

    return (dispatch, getState) => {
        dispatch(_processing(true));
        let {payload} = getState().loginForm.data;

        const request = axios({

            url: apiBaseUrl(`admin/login`),
            method: "post",
            dataType: 'json',
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + loginToken()
            }
        })
            .then(function (res) {

                dispatch(_processing(false));
                if(res.data.status === 401){
                    notifyLoginError(res.data)
                    store.dispatch(cancelLoginFormDispatch())
                }
                else{
                    dispatch(_success(res));
                }
            }).catch(function (error) {
                dispatch(_error(error));
                dispatch(_processing(false));

                store.dispatch(cancelLoginFormDispatch())
                if (error.response && error.response.status === 422) {
                    store.dispatch(loginFormServerValidationErrors(error.response.data.errors))
                    scrollToError()
                } else {
                    notifyLoginError(error.response && error.response.data)
                }
            });

        return {
            type: 'LOGIN_USER_SUCCESS',
            payload: request
        }
    }
}

export default loginUser;